import React, { useState, useEffect } from "react";
//import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { Box, Typography, TextField, Button, IconButton, Container, Snackbar, Alert } from "@mui/material";
import SEO from "../../common/SEO";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Grid from "../../common/CustomGrid";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { getCalendarData, saveCalendarData, sendContactEmail } from "../../../services/calendar";
import dayjs from "dayjs";

const ContactPage = () => {
  //const navigate = useNavigate();
  //const location = useLocation();

  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    telefono: "",
    mensaje: "",
    fecha: dayjs().format("YYYY-MM-DD"),
    hora: "",
  });
  const [errors, setErrors] = useState({});
  const [calendarData, setCalendarData] = useState([]);
  const [availableSlots, setAvailableSlots] = useState([
    { time: "11:00", available: true },
    { time: "12:00", available: true },
    { time: "13:00", available: true },
    { time: "14:00", available: true },
    { time: "15:00", available: true },
    { time: "16:00", available: true },
  ]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    fetchCalendarData();
  }, []);

  useEffect(() => {
    const date = dayjs().format("YYYY-MM-DD")
    setSlots(date)
  }, [calendarData]);

  const fetchCalendarData = async () => {
    const response = await getCalendarData();
    setCalendarData(response.data.data || []);
  };

  /* const handleBack = () => {
    if (location.key === 'default') {
      navigate('/');
  } else {
      navigate(-1);
  }
  }; */

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const setSlots = (formatDate)=>{
    const datesTaken = calendarData.filter(date => date.Dia === formatDate);
    if (datesTaken){
      const updatedSlots = availableSlots.map((slot) => {
        const isUnavailable = datesTaken.some(
          (entry) => entry.Hora.startsWith(slot.time) 
        );
        return {
          ...slot,
          available: !isUnavailable,
        };
      });

      setAvailableSlots(updatedSlots);
    }
  }

  const handleDateChange = (newDate) => {
    const formatDate = newDate.format("YYYY-MM-DD")
    setSlots(formatDate)

    setFormData((prevData) => ({
      ...prevData,
      fecha: formatDate,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      fecha: "",
    }));
  };

  const handleSlotSelect = (slot) => {
    if (slot.available) {
      setFormData((prevData) => ({
        ...prevData,
        hora: slot.time,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        hora: "",
      }));
    } else {
      setSnackbarMessage("Este horario no está disponible.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const validateForm = () => {
    let valid = true;
    let newErrors = {};

    if (!formData.nombre.trim()) {
      newErrors.nombre = "El nombre es requerido.";
      valid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = "El correo electrónico es requerido.";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "El correo electrónico no es válido.";
      valid = false;
    }

    if (!formData.telefono.trim()) {
      newErrors.telefono = "El teléfono es requerido.";
      valid = false;
    } else if (!/^\d+$/.test(formData.telefono)) {
      newErrors.telefono = "El teléfono debe contener solo números.";
      valid = false;
    }

    if (!formData.mensaje.trim()) {
      newErrors.mensaje = "El mensaje es requerido.";
      valid = false;
    }

    if (!formData.fecha) {
      newErrors.fecha = "Debe seleccionar una fecha.";
      valid = false;
    }

    if (!formData.hora) {
      newErrors.hora = "Debe seleccionar una hora.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const body = {
        data: {
          nombre: formData.nombre,
          email: formData.email,
          mensaje: formData.mensaje,
          telefono: formData.telefono,
          dia: formData.fecha,
          hora: dayjs(formData.hora, "HH:mm").format("HH:mm:ss.SSS")
        },
      };

      const response = await saveCalendarData(body);

      if (response?.status === 201) {
        const data = response?.data?.data;
        if (data?.id) {

          await sendContactEmail({
            emailCliente: formData.email,
            subject: `Nueva Demo Agendada: ${formData.nombre}`,
            html: `
              <h3>Tienes una nueva solicitud de Demo</h3>
              <ul>
                  <li><strong>Cliente:</strong> ${formData.nombre}</li>
                  <li><strong>Email:</strong> ${formData.email}</li>
                  <li><strong>Teléfono:</strong> ${formData.telefono}</li>
                  <li><strong>Fecha solicitada:</strong> ${formData.fecha}</li>
                  <li><strong>Hora:</strong> ${formData.hora}</li>
              </ul>
              <p><strong>Mensaje del cliente:</strong></p>
              <p><em>"${formData.mensaje}"</em></p>
            `,
            text: `Nuevo contacto de ${formData.nombre}. Tel: ${formData.telefono}. Mensaje: ${formData.mensaje}`          });
          
          setSnackbarMessage("Formulario enviado con éxito.");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          setFormData({
            nombre: "",
            email: "",
            telefono: "",
            mensaje: "",
            fecha: dayjs().format("YYYY-MM-DD"),
            hora: "",
          });
          await fetchCalendarData()
        } else {
          //alert("El formulario se envió, pero no se recibió un ID válido.");
          setSnackbarMessage("El formulario se envió, pero no se recibió un ID válido.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } else {
        const error = response?.response?.data?.error
        //console.error("Error en la respuesta:", error);
        //alert( `Hubo un error al enviar el formulario: ${error?.message}` );
        setSnackbarMessage(`Hubo un error al enviar el formulario: ${error?.message}`);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } else {
      setSnackbarMessage("Hay errores en el formulario. Revísalos antes de enviar.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  return (
    <Box className="contact-page">
      <SEO 
        title="Contacto | Hablemos de tu proyecto — E2E Travel Solutions"
        description="Contanos tu necesidad. Te ayudamos a definir la mejor solución tecnológica para vender, operar e integrar productos turísticos."
      />
      <Container maxWidth="md">
        <Box className="link-back">
          <IconButton component={Link} to="/"  sx={{ marginRight: "8px" }}>
            <ArrowBackIosIcon color="primary" />
          </IconButton>
          <Typography component={Link} to="/" variant="body1">
            Volver a <strong>solución</strong>
          </Typography>
        </Box>
        <Box className="contact-card">
          <Typography
            variant="h4"
            component="h1"
            sx={{ textAlign: "center", marginBottom: "20px" }}
          >
            Agenda una Demo
          </Typography>
          <Grid container spacing={4} alignItems="center">
            <Grid size={{ xs: 12, md: 6 }}>
              <Box className="main-box-calendar">
                <Box className="box-calendar">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                      value={dayjs(formData.fecha)}
                      onChange={handleDateChange}
                      shouldDisableDate={(date) => {
                        return date.isBefore(dayjs(), "day");
                      }}
                    />
                  </LocalizationProvider>
                  <Typography
                    variant="h6"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 1,
                      mb: 2,
                      fontWeight: "bold",
                      fontSize: { xs: 14, md: 16 },
                    }}
                  >
                    <AccessTimeIcon sx={{ mr: 1 }} /> Selecciona un horario:
                  </Typography>
                  <Grid container spacing={2}>
                    {availableSlots.map((slot, index) => (
                      <Grid key={index} size={{ xs: 4 }}>
                        <Button
                          fullWidth
                          variant="contained"
                          color={slot.available ? "primary" : "error"}
                          disabled={!slot.available}
                          onClick={() => handleSlotSelect(slot)}
                          startIcon={
                            formData.hora === slot.time ? (
                              <CheckCircleIcon sx={{ color: "white" }} />
                            ) : null
                          }
                          sx={{
                            padding: "8px 12px",
                            backgroundColor:
                              formData.hora === slot.time
                                ? "success.main"
                                : slot.available
                                ? "primary.main"
                                : "error.main",
                          }}
                        >
                          {slot.time}
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
                {errors.fecha && (
                  <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                    {errors.fecha}
                  </Typography>
                )}
                {errors.hora && (
                  <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                    {errors.hora}
                  </Typography>
                )}
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Box component="form" onSubmit={handleSubmit}>
                <TextField
                  label="Nombre"
                  variant="outlined"
                  fullWidth
                  required
                  name="nombre"
                  error={!!errors.nombre}
                  helperText={errors.nombre}
                  value={formData.nombre}
                  onChange={handleChange}
                />
                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  required
                  type="email"
                  name="email"
                  value={formData.email}
                  error={!!errors.email}
                  helperText={errors.email}
                  onChange={handleChange}
                />
                <TextField
                  label="Teléfono"
                  variant="outlined"
                  fullWidth
                  required
                  name="telefono"
                  value={formData.telefono}
                  error={!!errors.telefono}
                  helperText={errors.telefono}
                  onChange={handleChange}
                />
                <TextField
                  label="Mensaje"
                  multiline
                  rows={4}
                  variant="outlined"
                  fullWidth
                  required
                  name="mensaje"
                  value={formData.mensaje}
                  error={!!errors.mensaje}
                  helperText={errors.mensaje}
                  onChange={handleChange}
                />
                <Button
                  size="small"
                  className="submit-button"
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Enviar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snackbarSeverity} onClose={() => setSnackbarOpen(false)}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ContactPage;
